import { Model } from '../model';
import { Paginated } from '../paginated';

export class SmsSender extends Model {
  sender: string;
  id?: number;
  type?: string;
}

export class SmsSenders extends Paginated {
  data: Array<SmsSender>;
}

export class SmsSenderAgcom extends Model {
  idSender: number;
  sender: string;
  status: string;
  numeric: boolean;
  lastNotifyAliasDate?: string;
  agcomTpoaUserDTO?: any;
}

export class SmsSendersAgcom extends Paginated {
  data: Array<SmsSenderAgcom>;
}

export class SmsSenderAgcomSisNumeric extends Model {
  idSender: number;
  sender: string;
  status: string;
  numeric: boolean;
  lastNotifyAliasDate?: string;
  agcomTpoaUserDTO?: any;
}

export class SmsSendersAgcomSisNumeric extends Paginated {
  data: Array<SmsSenderAgcomSisNumeric>;
}

export class SmsSenderAgcomSisAlphaNumeric extends Model {
  idSender: number;
  sender: string;
  status: string;
  statusLabel: string;
  type: string;
  lastUpdate?: string;
  companyInfo?: any;
}

export class SmsSendersAgcomSisAlphaNumeric extends Paginated {
  data: Array<SmsSenderAgcomSisAlphaNumeric>;
}
